module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.25649",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6283",
      "conversations-error-reporting": "static-1.7566",
      "conversations-internal-pub-sub": "static-1.14625",
      "conversations-internal-schema": "static-1.11262",
      "conversations-message-history": "static-1.9697",
      "conversations-test-sdk": "static-1.9083",
      "conversations-visitor-experience-components": "static-1.19012",
      "head-dlb": "static-1.3679",
      "hs-promise-utils": "static-1.4126",
      "hs-test-utils": "static-1.6619",
      "hubspot-dlb": "static-2.1317",
      "HubStyleTokens": "static-2.10103",
      "I18n": "static-7.1368",
      "jasmine-immutable": "static-1.1572",
      "jasmine-runner": "static-1.5008",
      "quartz": "static-1.5365",
      "react-aria": "static-1.38",
      "react-dlb": "static-1.51",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3156",
      "viral-links-lib": "static-1.5477",
      "visitor-ui-component-library": "static-1.4809",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3196",
      "atom": "static-1.3858",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3401",
      "conversations-infrastructure": "static-1.7529",
      "conversations-prop-types": "static-1.6043",
      "conversations-visibility-tools": "static-1.4376",
      "conversations-visitor-message-history": "static-1.17749",
      "cssUtils": "static-1.455",
      "enviro": "static-4.293",
      "flux-actions": "static-1.266",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.2969",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8343",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.272",
      "raven": "static-3.4440",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15214",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4171",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.2982",
      "sanitize-text": "static-1.6804",
      "signup-constants": "static-1.15852",
      "styled-components": "static-2.40",
      "StyleGuideUI": "static-3.453",
      "usage-tracker": "static-1.6079",
      "usage-tracker-core": "static-1.5929",
      "usage-tracker-multi": "static-1.4493",
      "usage-tracker-public": "static-1.5890",
      "visitor-ui-component-library-icons": "static-1.4620",
      "hs-promise-rejection-tracking": "static-1.3967",
      "raven-hubspot": "static-1.4747",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2286",
      "moment": "static-3.26",
      "quartz-core": "static-1.4584",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3529",
      "foundations-components": "static-1.5777",
      "foundations-theming": "static-1.2925",
      "UIComponents": "static-3.7052",
      "conversations-skeleton-state": "static-1.6008",
      "cv-backend-services": "static-1.1110",
      "icons": "static-2.591",
      "react-input-autosize": "static-2.17",
      "ui-images": "static-2.804",
      "permission-components": "static-1.3991",
      "react-virtualized": "static-2.73",
      "HeadJS": "static-2.562",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1730",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "i18n-data": "static-1.196",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.2964",
      "quartz-core-utils": "static-1.2232",
      "signup-ui-url-generator": "static-2.6665",
      "HubStyle": "static-2.10412",
      "sassPrefix": "static-1.129",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4496",
      "copilot-toolkit": "static-1.5567",
      "dispatcher": "static-1.111",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.633",
      "hub-http-shared-msw-handlers": "static-1.6842",
      "hubspotter-http": "static-1.3405",
      "hubspotter-http-shared-msw-handlers": "static-1.6840",
      "mobile-manifest-mixins": "static-1.333",
      "platform-navigation-bootstrap": "static-1.11006",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.331",
      "hs-story-utils": "static-1.8004",
      "bend-plugin-foundations-components": "static-1.2045",
      "floating-ui": "static-1.28",
      "foundations-theming-specialty": "static-1.642",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1408",
      "foundations-theming-base": "static-1.1910",
      "rpc-client-utils": "static-1.3343",
      "ts-schema": "static-1.2983",
      "chatspot-client-types": "static-1.8340",
      "chatspot-core": "static-1.14803",
      "platform-infra-nav-components": "static-1.6532"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.25649",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6283",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7566",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14625",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11262",
      "conversations-message-history": "/conversations-message-history/static-1.9697",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9083",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19012",
      "head-dlb": "/head-dlb/static-1.3679",
      "hs-promise-utils": "/hs-promise-utils/static-1.4126",
      "hs-test-utils": "/hs-test-utils/static-1.6619",
      "hubspot-dlb": "/hubspot-dlb/static-2.1317",
      "HubStyleTokens": "/HubStyleTokens/static-2.10103",
      "I18n": "/I18n/static-7.1368",
      "jasmine-immutable": "/jasmine-immutable/static-1.1572",
      "jasmine-runner": "/jasmine-runner/static-1.5008",
      "quartz": "/quartz/static-1.5365",
      "react-aria": "/react-aria/static-1.38",
      "react-dlb": "/react-dlb/static-1.51",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3156",
      "viral-links-lib": "/viral-links-lib/static-1.5477",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.4809",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3196",
      "atom": "/atom/static-1.3858",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3401",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7529",
      "conversations-prop-types": "/conversations-prop-types/static-1.6043",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4376",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.17749",
      "cssUtils": "/cssUtils/static-1.455",
      "enviro": "/enviro/static-4.293",
      "flux-actions": "/flux-actions/static-1.266",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2969",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8343",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.272",
      "raven": "/raven/static-3.4440",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15214",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4171",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.2982",
      "sanitize-text": "/sanitize-text/static-1.6804",
      "signup-constants": "/signup-constants/static-1.15852",
      "styled-components": "/styled-components/static-2.40",
      "StyleGuideUI": "/StyleGuideUI/static-3.453",
      "usage-tracker": "/usage-tracker/static-1.6079",
      "usage-tracker-core": "/usage-tracker-core/static-1.5929",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4493",
      "usage-tracker-public": "/usage-tracker-public/static-1.5890",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4620",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
      "raven-hubspot": "/raven-hubspot/static-1.4747",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2286",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4584",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3529",
      "foundations-components": "/foundations-components/static-1.5777",
      "foundations-theming": "/foundations-theming/static-1.2925",
      "UIComponents": "/UIComponents/static-3.7052",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6008",
      "cv-backend-services": "/cv-backend-services/static-1.1110",
      "icons": "/icons/static-2.591",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "ui-images": "/ui-images/static-2.804",
      "permission-components": "/permission-components/static-1.3991",
      "react-virtualized": "/react-virtualized/static-2.73",
      "HeadJS": "/HeadJS/static-2.562",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1730",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "i18n-data": "/i18n-data/static-1.196",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.2964",
      "quartz-core-utils": "/quartz-core-utils/static-1.2232",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6665",
      "HubStyle": "/HubStyle/static-2.10412",
      "sassPrefix": "/sassPrefix/static-1.129",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4496",
      "copilot-toolkit": "/copilot-toolkit/static-1.5567",
      "dispatcher": "/dispatcher/static-1.111",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.633",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6842",
      "hubspotter-http": "/hubspotter-http/static-1.3405",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6840",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.333",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11006",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.331",
      "hs-story-utils": "/hs-story-utils/static-1.8004",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2045",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.642",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1408",
      "foundations-theming-base": "/foundations-theming-base/static-1.1910",
      "rpc-client-utils": "/rpc-client-utils/static-1.3343",
      "ts-schema": "/ts-schema/static-1.2983",
      "chatspot-client-types": "/chatspot-client-types/static-1.8340",
      "chatspot-core": "/chatspot-core/static-1.14803",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6532"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};